var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 0H3.16667C1.40917 0 0.0158333 1.40917 0.0158333 3.16667L0 22.1667C0 23.9242 1.40917 25.3333 3.16667 25.3333H28.5C30.2575 25.3333 31.6667 23.9242 31.6667 22.1667V3.16667C31.6667 1.40917 30.2575 0 28.5 0ZM28.5 22.1667H3.16667V12.6667H28.5V22.1667ZM28.5 6.33333H3.16667V3.16667H28.5V6.33333Z",
    fill: "#FCBC5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.988c2ffffc6a2269c24ac5510469d9af.svg";
export { ForwardRef as ReactComponent };